/**
 * Ryan O'Dowd
 * 2018-02-05
 * © Copyright 2018 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = ({fonts, globalScale, colors, isDarkMode, safeAreaInsets}) => {
  return {
    centerComponentWrapper: {
      // @TODO: flex: 1,
      flexShrink: 1,
      flexDirection: 'row',
      justifyContent: Platform.OS === 'ios' ? 'center' : 'flex-start',
    },
    centerComponentInner: {
      display: 'flex',
      flexShrink: 1,
      flexDirection: 'row',
    },
    betaTitleText: {
      width: 'auto',
    },
    betaSuperscript: {
      display: 'flex',
      flexShrink: 1,
      color: colors.accent,
      fontSize: globalScale * 10,
      fontFamily: fonts.primaryBold,
    },
    settingsListContainer: { // @TODO: combine with SectionList (pass prop to say flat or section?)
      gap: 4,
      paddingBottom: safeAreaInsets.bottom + 4,
    },
    deleteAccountText: {
      color: colors.alert,
    },

    // @TODO: abstract these with Home settings dialog
    sectionWrapper: { // @TODO: in the dialog...could probably be in commonStyles
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      marginBottom: globalScale * 8, // @TODO: don't need this for licensing info dialog
    },
    contentWrapper: { // @TODO: remove
      flex: 1,
      width: '100%',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    section: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
    },
    gap: {
      height: 32,
    },
    buttonAndSizeWrapper: {
      justifyContent: 'center',
      alignItems: 'flex-end',
      marginTop: 16,
    },
    sizeText: {
      fontSize: globalScale * 12,
      color: colors.gray,
      fontFamily: fonts.primaryItalic,
      marginTop: globalScale * 4,
    },
    descriptionText: {
      fontSize: globalScale * 14,
      color: isDarkMode ? colors.white : colors.black,
    },
    buttonGroupWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      flexWrap: 'wrap',
      marginTop: globalScale * 8,
      padding: globalScale * 4,
      fontSize: globalScale * 14,
      // @TODO: marginBottom: 0, // @TODO: not working?

      width: '100%',
    },
    translationSettingsIcon: {
      marginTop: 0,
      marginBottom: 0,
      marginRight: 0, // @NOTE: this removes the double padding for cogs
    },
  };
};

export default getStyles;
